import React, { useState, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";
import * as language from "../../utils/language.js";
import * as rwData from "../../utils/rwData.js";
import { is } from "date-fns/locale";

const Handeingriff = observer((props) => {
  //========================================================================
  // Wert aus globalVars auslesen
  let value = rwData.readRcvValue(props.props.variable);

  //========================================================================
  // Simulation
  let simulation = false;
  let simValue = 0;

  try {
    simulation = props.style.properties.simulation;
    simValue = props.style.properties.simValue;
  } catch (error) {
    simulation = false;
  }

  if (simulation) {
    if (simValue == 1) {
      value.value = "1";
    } else {
      value.value = "0";
    }
  }

  //========================================================================
  // Auswerten, ob Aktiv
  let isActive;
  if (value.value === "1") {
    isActive = true;
  } else {
    isActive = false;
  }

  //========================================================================
  // State für Blinkeffekt
  const [isBlinkVisible, setIsBlinkVisible] = useState(true);

  //========================================================================
  // useEffect für Blinklogik
  useEffect(() => {
    let blinkInterval;

    if (isActive) {
      // Setze ein Intervall, das den Sichtbarkeitsstatus toggelt
      blinkInterval = setInterval(() => {
        setIsBlinkVisible((prev) => !prev);
      }, 500); // Blinkgeschwindigkeit: 500ms
    } else {
      // Wenn nicht aktiv, stelle sicher, dass das Bild ausgeblendet ist
      setIsBlinkVisible(false);
    }

    // Bereinige das Intervall, wenn die Komponente unmountet wird oder sich isActive ändert
    return () => {
      if (blinkInterval) {
        clearInterval(blinkInterval);
      }
    };
  }, [isActive]);

  //========================================================================
  // Bilder laden
  const pathHand = require("../../images/controls/Handeingriff/Handeingriff.png");
  const imagePath = pathHand;

  //========================================================================
  // Bestimme die Sichtbarkeit des Bildes
  const shouldDisplay = isActive ? isBlinkVisible : false;

  return (
    <img
      style={{
        ...props.style,
        visibility: isActive ? props.props.visibility : "collapse",
        opacity: shouldDisplay ? 1 : 0,
        transition: "opacity 0.1s ease-in-out", // Optional: sanfter Übergang
      }}
      title={
        language.displayText(value.name) +
        (globalVars.cyclicUpdate || globalVars.editor
          ? "\n" + ("Variable: " + props.props.variable)
          : "")
      }
      src={imagePath}
    />
  );
});

export default Handeingriff;
